const RTEs = {};

export default {
  getRTE(type) {
    return RTEs[type]
  }
};

(function ($) {
  RTEs.ckeditor = {

    init: function (settings, contentAreas) {
      if (!window.CKEDITOR) {
        console.error(
          'CKEditor not available! Make sure you loaded the ckeditor and jquery adapter js files.'
        )
      }

      var self = this
      contentAreas.each(function () {
        var contentArea = $(this)
        if (!contentArea.hasClass('active')) {
          if (contentArea.html() == self.initialContent) {
            // CKEditor kills this '&nbsp' creating a non usable box :/
            contentArea.html('&nbsp;')
          }

          // Add the .attr('contenteditable',''true') or CKEditor loads readonly
          contentArea.addClass('active').attr('contenteditable', 'true')

          var configuration = $.extend(
            {},
            (settings.ckeditor && settings.ckeditor.config ? settings.ckeditor.config : {}),
            {
              // Focus editor on creation
              on: {
                instanceReady: function (evt) {
                  // Call original instanceReady function, if one was passed in the config
                  var callback
                  try {
                    callback = settings.ckeditor.config.on.instanceReady
                  } catch (err) {
                    // No callback passed
                  }
                  if (callback) {
                    callback.call(this, evt)
                  }

                  instance.focus()
                }
              }
            }
          )
          var instance = CKEDITOR.inline(contentArea.get(0), configuration)
        }
      })
    },

    deinit: function (settings, contentAreas) {
      contentAreas.filter('.active').each(function () {
        var contentArea = $(this)

        // Destroy all CKEditor instances
        $.each(CKEDITOR.instances, function (_, instance) {
          instance.destroy()
        })

        // Cleanup
        contentArea
          .removeClass('active cke_focus')
          .removeAttr('id')
          .removeAttr('style')
          .removeAttr('spellcheck')
          .removeAttr('contenteditable')
      })
    },

    initialContent: '<p>Lorem initius... </p>'
  }
})(jQuery);
(function ($) {
  RTEs.summernote = {

    init: function (settings, contentAreas) {
      if (!jQuery().summernote) {
        console.error('Summernote not available! Make sure you loaded the Summernote js file.')
      }

      var self = this
      contentAreas.each(function () {
        var contentArea = $(this)
        if (!contentArea.hasClass('active')) {
          if (contentArea.html() == self.initialContent) {
            contentArea.html('')
          }
          contentArea.addClass('active')

          var configuration = $.extend(
            true, // deep copy
            {},
            (settings.summernote && settings.summernote.config ? settings.summernote.config : {}),
            {
              tabsize: 2,
              airMode: true,
              // Focus editor on creation
              callbacks: {
                onInit: function () {
                  // Call original oninit function, if one was passed in the config
                  var callback
                  try {
                    callback = settings.summernote.config.callbacks.onInit
                  } catch (err) {
                    // No callback passed
                  }
                  if (callback) {
                    callback.call(this)
                  }

                  contentArea.summernote('focus')
                }
              }
            }
          )
          contentArea.summernote(configuration)
        }
      })
    },

    deinit: function (settings, contentAreas) {
      contentAreas.filter('.active').each(function () {
        var contentArea = $(this)
        contentArea.summernote('destroy')
        contentArea
          .removeClass('active')
          .removeAttr('id')
          .removeAttr('style')
          .removeAttr('spellcheck')
      })
    },

    initialContent: '<p>Lorem ipsum dolores</p>'
  }
})(jQuery);

(function ($) {
  RTEs.tinymce = {
    init: function (settings, contentAreas) {
      if (!window.tinymce) {
        console.error('tinyMCE not available! Make sure you loaded the tinyMCE js file.')
      }
      if (!contentAreas.tinymce) {
        console.error('tinyMCE jquery integration not available! Make sure you loaded the jquery integration plugin.')
      }
      var self = this
      contentAreas.each(function () {
        var contentArea = $(this)
        if (!contentArea.hasClass('active')) {
          if (contentArea.html() == self.initialContent) {
            contentArea.html('')
          }
          contentArea.addClass('active')
          var configuration = $.extend(
            {},
            (settings.tinymce && settings.tinymce.config ? settings.tinymce.config : {}),
            {
              inline: true,
              oninit: function (editor) {
                // Bring focus to text field
                $('#' + editor.settings.id).focus()

                // Call original oninit function, if one was passed in the config
                var callback
                try {
                  callback = settings.tinymce.config.oninit
                } catch (err) {
                  // No callback passed
                }

                if (callback) {
                  callback.call(this)
                }
              }
            }
          )
          var tiny = contentArea.tinymce(configuration)
        }
      })
    },

    deinit: function (settings, contentAreas) {
      contentAreas.filter('.active').each(function () {
        var contentArea = $(this)
        var tiny = contentArea.tinymce()
        if (tiny) {
          tiny.remove()
        }
        contentArea
          .removeClass('active')
          .removeAttr('id')
          .removeAttr('style')
          .removeAttr('spellcheck')
      })
    },

    initialContent: '<p>Lorem ipsum dolores</p>'
  }
})(jQuery)
